import { useLang } from '@/i18n';
import { getSolarRecommand } from '@/service/solar-calculator';
import gtm from '@/utils/gtm';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import ShopifyShoppingCart from 'elem/compCommon/ShopifyShoppingCart';
import { ShopifyCartItemType } from 'elem/compCommon/ShopifyShoppingCart/const';
import { langText } from 'elem/compPage/Delta3Series/detail/comps/P/EFCardCartLists/langText';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import NavProduct from '../tabs/NavProduct';
import TabBundles from '../tabs/TabBundles';
import TabMedia from '../tabs/TabMedia';
import TabSpecs from '../tabs/TabSpecs';
import TabSupport from '../tabs/TabSupport';
import styles from './index.module.scss';
import ProductContent from './ProductContent';

const theme = 'white';
const tabList = ['Product', 'Support', 'Specs', 'Media'];
export default function Detail() {
    const { productTabActive } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { locale, query } = router;
    const tabName: string = (query.tab as string) || '';
    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState([]);
    const [visible, setVisible] = useState(false);
    const { t } = useLang('theProduct.ListC');
    const i18n = langText[locale] || langText.us;

    const items: any[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1723030469186/a1.png',
            tag: t('a_label'),
            title: t('a_title'),
            desc: t('a_desc'),
            productId: '7213436534857',
            variantId: '44505650528417',
            quantity: 1,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1724639717832/listC_2.png',
            tag: t('b_label'),
            title: t('b_title'),
            desc: t('b_desc'),
            desc: `${t('P_card2_power')}\n${t('P_card2_desc')}`,
            productId: '7213436534857',
            variantId: '44505652854945',
            quantity: 1,
        },
        // {
        //     img: 'https://websiteoss.ecoflow.com/upload/image/1723030469537/a3.png',
        //     tag: t('c_label'),
        //     title: t('c_title'),
        //     desc: t('c_desc'),
        //     //productId: '7213436534857',
        //     //variantId: '41435086618697',
        //     quantity: 1,
        //     btnCartText: '11月中旬発売',
        // },
    ];

    const river3plus = {
        img: 'https://websiteoss.ecoflow.com/upload/image/1723030469537/a3.png',
        label: t('c_label'),
        title: t('c_title'),
        desc: t('c_desc'),
        quantity: 1,
        btnCartText: '11月中旬発売',
        inventory: 0,
    };

    const [cards, setCards] = useState(JSON.parse(JSON.stringify(items)));

    const getAsynItem = async (item: any) => {
        const { variantId, productId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.discountPrice = res?.data?.price ?? 0;
                    item.originalPrice = res?.data?.compareAtPrice ?? res?.data?.price ?? 0;
                    item.inventory = res?.data?.inventoryQuantity ?? 0;
                    item.img = res?.data?.img;
                    // item.inventory = 1;
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    if (res?.data?.productTitle || res?.data?.skuTitle) {
                        item.title = res?.data?.productTitle || res?.data?.skuTitle;
                    }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    const handleAddToCart = (card: any, list_name?: string) => {
        if (card?.inventory <= 0) {
            return;
        }
        const obj: ShopifyCartItemType = { ...card };
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === card?.productId && item?.variantId === card?.variantId);
        if (target) {
            obj.quantity = target.quantity + (target?.quantity < target.inventory ? 1 : 0);
            // setShoppingCarts([
            //     obj,
            //     ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            // ]);
            EcoDesignEventsBus.emit('eco-cart-add', [
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === card?.productId && item?.variantId === card?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            //setShoppingCarts([obj, ...shoppingCarts]);
            EcoDesignEventsBus.emit('eco-cart-add', [obj, ...shoppingCarts]);
        }
        setVisible(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            product_name: card?.name || card?.title,
            list_name: list_name || 'none',
            price: card?.discountPrice,
            tag: 'none',
            quantity: obj?.quantity,
            button_name: i18n.cart,
        });
    };

    const handleCallback = (carts: ShopifyCartItemType[], isClose?: boolean) => {
        //setShoppingCarts(carts);
        EcoDesignEventsBus.emit('eco-cart-add', carts);
        if (isClose) {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (locale === 'jp') {
            const tempArr = JSON.parse(JSON.stringify(items));
            const promises = tempArr?.map((item: any) => getAsynItem(item));
            Promise.all(promises)
                .then(() => {
                    console.log('tempArr', tempArr);
                    setCards(tempArr);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    });

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    return (
        <div className={styles.detail}>
            <NavProduct />
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent callbackCart={handleAddToCart} bundles={[...cards, river3plus]} />
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles callbackCart={handleAddToCart} />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} />
                </div>
            )}
            <div className={`product-item-tab${productTabActive === 'Media' ? ' product-item-tab-active' : ''}`}>
                <TabMedia />
            </div>
            {visible && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem.quantity);
                        }, 0)}
                        callback={() => setVisible(true)}
                    />,
                    document.body,
                )}
        </div>
    );
}
